export default "__VITE_PUBLIC_ASSET__63a1616e__"